import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link, withRouter } from "react-router-dom";
import Modal from "react-modal";
import styled from "styled-components";
import { Translate } from "react-redux-i18n";
import Constants from "../../AppConstants/Constants";
import { updateAlreadyApprovedModalState } from "../../Store/Modals/Actions";
Modal.setAppElement("#react-app");

// region Style
const ModalBody = styled.div`
    padding: 40px 80px;
    
    // Extra small devices (portrait phones, less than 576px)
    @media (max-width: 575.98px) {
       padding: 40px 15px; 
    }
    
    // Medium devices (tablets, 768px and up)
    @media (min-width: 768px) {
        padding: 40px 20px;
    }
`;

const CloseButton = styled.div`
    display: none;
    
    // Small devices (landscape phones, less than 768px)
    @media (max-width: 767.98px) {
        display: block;
    }
`;

const Logo = styled.img`  
    width: 100px;
    
    // Large devices (desktops, 992px and up)
    @media (min-width: 992px) and (max-width: 1199.98px) {
        width: 80px;
    }
`;

const Box = styled.div`
    .col-lg-6:last-of-type & {
        margin-bottom: 0;
    }
  
    // Large devices (desktops, 992px and up)
    @media (min-width: 992px) {
        margin-bottom: 0;
        height: 100%;
    }
`;

const FlexRow = styled.div`
    // Extra large devices (large desktops, 1200px and up)
    @media (min-width: 992px) {
        display: flex;
    }
`;

const LeaseRow = styled.div`
    margin-bottom: 10px;
`;

const FlexColumn = styled.div`
    ${FlexRow} & {
        // Extra large devices (large desktops, 1200px and up)
        @media (min-width: 992px) {
            flex: 1;
        }
    }
`;

const CustomRow = styled.div`
    // Small devices (landscape phones, less than 768px)
    @media (max-width: 767.98px) {
        margin-left: 0;
        margin-right: 0;
    }
`;

const Button = styled.button`
    width: 130px;
`;

const CustomP = styled.p`
    line-height: 1.5em;
    font-size: 8pt;
    
    ${LeaseRow} & {
        font-size: 10pt;
    }
`;
// endregion

class AlreadyApprovedModal extends Component {
    constructor(props) {
        super(props);

        this.closeModal = this.closeModal.bind(this);
    }

    closeModal() {
        const { updateAlreadyApprovedModalState } = this.props;

        updateAlreadyApprovedModalState(false);
    }

    render() {
        const { alreadyApprovedModalOpen } = this.props;

        return (
            <Modal
                isOpen={alreadyApprovedModalOpen}
                onRequestClose={this.closeModal}
                contentLabel="already approved alert"
                className="modal-content"
                overlayClassName="modal-container already-approved-modal modal-active"
            >
                <ModalBody className="modal-body">
                    <div className="row justify-content-center" style={{ marginBottom: 20 }}>
                        <div className="col-6">
                            <div className="bar__module text-center">
                                <Link to="#" style={{ cursor: "auto" }}>
                                    <Logo className="logo logo-light logo-desktop" alt="logo" src={require("../../../Assets/Images/logo-velocitor.png")}/>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <FlexRow className="row justify-content-center">
                        <FlexColumn className="col-lg-6">
                            <Box className="boxed boxed--border">
                                <h3 className="text-center"><strong><Translate value="modals.alreadyApproved.cartReady.title" /></strong></h3>

                                <CustomRow className="row justify-content-center" style={{ marginTop: 40 }}>
                                    <div className="col-md-12">
                                        <CustomP>
                                            <strong>
                                                <Translate value="modals.alreadyApproved.cartReady.description" />
                                            </strong>
                                        </CustomP>
                                    </div>
                                </CustomRow>

                                <div className="row justify-content-center" style={{ marginTop: 20 }}>
                                    <div className="col-md-5 text-center">
                                        <Link to={Constants.ENDPOINTS.CART} onClick={this.closeModal}>
                                            <Button type="button" className="btn btn--primary type--uppercase"><Translate value="modals.alreadyApproved.cartReady.btn" /></Button>
                                        </Link>
                                    </div>
                                </div>
                            </Box>
                        </FlexColumn>

                        <FlexColumn className="col-lg-6">
                            <Box className="boxed boxed--border">
                                <h3 className="text-center"><strong><Translate value="modals.alreadyApproved.continueShopping.title" /></strong></h3>

                                <CustomRow className="row justify-content-center" style={{ marginTop: 40 }}>
                                    <div className="col-md-12">
                                        <CustomP>
                                            <strong>
                                                <Translate value="modals.alreadyApproved.continueShopping.description" />
                                            </strong>
                                        </CustomP>
                                    </div>
                                </CustomRow>

                                <div className="row justify-content-center" style={{ marginTop: 20 }}>
                                    <div className="col-md-5 text-center">
                                        <Link to={Constants.ENDPOINTS.HOME} onClick={this.closeModal}>
                                            <Button type="button" className="btn btn--primary type--uppercase"><Translate value="modals.alreadyApproved.continueShopping.btn" /></Button>
                                        </Link>
                                    </div>
                                </div>
                            </Box>
                        </FlexColumn>
                    </FlexRow>
                </ModalBody>
                <CloseButton className="modal-close modal-close-cross" onClick={this.closeModal}/>
            </Modal>
        );
    }
}

AlreadyApprovedModal.propTypes = {
    updateAlreadyApprovedModalState: PropTypes.func,
    alreadyApprovedModalOpen: PropTypes.bool
};

function mapStateToProps(state) {
    return {
        alreadyApprovedModalOpen: state.alreadyApprovedModalOpen
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateAlreadyApprovedModalState: updateAlreadyApprovedModalState
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AlreadyApprovedModal));